"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationTypeEnum = void 0;
var OperationTypeEnum;
(function (OperationTypeEnum) {
    /** Basic Operation Types */
    OperationTypeEnum["FETCH"] = "FETCH";
    OperationTypeEnum["INSERT"] = "INSERT";
    OperationTypeEnum["UPDATE"] = "UPDATE";
    OperationTypeEnum["BULK_UPDATE"] = "BULK_UPDATE";
    OperationTypeEnum["BULK_INSERT"] = "BULK_INSERT";
    OperationTypeEnum["BULK_DELETE"] = "BULK_DELETE";
    OperationTypeEnum["BULK_EXPORT"] = "BULK_EXPORT";
    OperationTypeEnum["DELETE"] = "DELETE";
    OperationTypeEnum["RESTORE"] = "RESTORE";
    OperationTypeEnum["LOGIN"] = "LOGIN";
    OperationTypeEnum["LOGOUT"] = "LOGOUT";
    OperationTypeEnum["SHARED"] = "SHARED";
    /** User */
    OperationTypeEnum["UPDATE_USER_ROLE"] = "UPDATE_USER_ROLE";
    OperationTypeEnum["INVITE_USER"] = "INVITE_USER";
    OperationTypeEnum["UPDATE_USER_APPROVAL_DATA"] = "UPDATE_USER_APPROVAL_DATA";
    /** Employee */
    OperationTypeEnum["UPDATE_EMPLOYEE_ABSENCE"] = "UPDATE_EMPLOYEE_ABSENCE";
    /** Expenses */
    OperationTypeEnum["APPROVE_EXPENSE"] = "APPROVE_EXPENSE";
    OperationTypeEnum["DECLINED_EXPENSE"] = "DECLINED_EXPENSE";
    OperationTypeEnum["REVIEWED_EXPENSE"] = "REVIEWED_EXPENSE";
    OperationTypeEnum["PAID_EXPENSE"] = "PAID_EXPENSE";
    OperationTypeEnum["DOCUMENT_EXPENSE"] = "DOCUMENT_EXPENSE";
    OperationTypeEnum["DOCUMENT_NEEDED_EXPENSE"] = "DOCUMENT_NEEDED_EXPENSE";
    OperationTypeEnum["UPDATE_PROFILE_IMG"] = "UPDATE_PROFILE_IMG";
    OperationTypeEnum["INSERT_COMMENT"] = "INSERT_COMMENT";
    OperationTypeEnum["UPDATE_COMMENT"] = "UPDATE_COMMENT";
    OperationTypeEnum["DELETE_COMMENT"] = "DELETE_COMMENT";
    OperationTypeEnum["MENTION_COMMENT"] = "MENTION_COMMENT";
    OperationTypeEnum["INSERT_SUBSCRIPTION"] = "INSERT_SUBSCRIPTION";
    OperationTypeEnum["UPDATE_SUBSCRIPTION"] = "UPDATE_SUBSCRIPTION";
    OperationTypeEnum["DELETE_SUBSCRIPTION"] = "DELETE_SUBSCRIPTION";
    OperationTypeEnum["INSERT_RECURRING_EXPENSE"] = "INSERT_RECURRING_EXPENSE";
    OperationTypeEnum["UPLOAD_INVOICE_REMINDER"] = "UPLOAD_INVOICE_REMINDER";
    OperationTypeEnum["UPLOAD_DOCUMENT"] = "UPLOAD_DOCUMENT";
    OperationTypeEnum["REMOVE_DOCUMENT"] = "REMOVE_DOCUMENT";
    OperationTypeEnum["APPROVE_REMINDER"] = "APPROVE_REMINDER";
    OperationTypeEnum["BILLED_EXPENSE"] = "BILLED_EXPENSE";
    OperationTypeEnum["ATTACH_TAG"] = "ATTACH_TAG";
    OperationTypeEnum["DETACH_TAG"] = "DETACH_TAG";
    OperationTypeEnum["INVOICE_AUTO_MATCH"] = "INVOICE_AUTO_MATCH";
    OperationTypeEnum["INBOX_ATTACH"] = "INBOX_ATTACH";
    OperationTypeEnum["ARCHIVE"] = "ARCHIVE";
    OperationTypeEnum["UNARCHIVE"] = "UNARCHIVE";
    OperationTypeEnum["RESET_STATUS"] = "RESET_STATUS";
    OperationTypeEnum["RESET_BANK_PAYMENT_STATUS"] = "RESET_BANK_PAYMENT_STATUS";
    OperationTypeEnum["EXPORT_EXPENSE"] = "EXPORT_EXPENSE";
    OperationTypeEnum["SYNC_VENDOR_DATA"] = "SYNC_VENDOR_DATA";
    OperationTypeEnum["ATTACH_TO_FOLDER"] = "ATTACH_TO_FOLDER";
    OperationTypeEnum["DETACH_FROM_FOLDER"] = "DETACH_FROM_FOLDER";
    OperationTypeEnum["FOLLOW_UP_EXPENSE"] = "FOLLOW_UP_EXPENSE";
    OperationTypeEnum["SUBMIT_DISCOUNTS"] = "SUBMIT_DISCOUNTS";
    OperationTypeEnum["DELETE_DISCOUNTS"] = "DELETE_DISCOUNTS";
    /** Bulk OPs */
    OperationTypeEnum["BULK_REVIEWED_EXPENSES"] = "BULK_REVIEWED_EXPENSES";
    OperationTypeEnum["BULK_PAID_EXPENSES"] = "BULK_PAID_EXPENSES";
    OperationTypeEnum["BULK_EXPORT_EXPENSES"] = "BULK_EXPORT_EXPENSES";
    /** DATEV RELATED */
    OperationTypeEnum["DATEV_ONLINE_EXPORT_WRONG_IMPORT_TARGET"] = "DATEV_ONLINE_EXPORT_WRONG_IMPORT_TARGET";
    OperationTypeEnum["DATEV_ONLINE_EXPORT_INVALID_GRANT"] = "DATEV_ONLINE_EXPORT_INVALID_GRANT";
    OperationTypeEnum["DATEV_ONLINE_EXPORT"] = "DATEV_ONLINE_EXPORT";
    OperationTypeEnum["DATEV_ONLINE_EXPORT_SUCCESS"] = "DATEV_ONLINE_EXPORT_SUCCESS";
    OperationTypeEnum["DATEV_ONLINE_EXPORT_ERROR"] = "DATEV_ONLINE_EXPORT_ERROR";
    OperationTypeEnum["DATEV_ONLINE_EXPORT_PARTIAL"] = "DATEV_ONLINE_EXPORT_PARTIAL";
    OperationTypeEnum["DATEV_ONLINE_EXPORT_MISSING_ACCOUNT_MONTH"] = "DATEV_ONLINE_EXPORT_MISSING_ACCOUNT_MONTH";
    OperationTypeEnum["DATEV_ONLINE_UNSUPPORTED_FILE_TYPE"] = "DATEV_ONLINE_UNSUPPORTED_FILE_TYPE";
    OperationTypeEnum["DATEV_ONLINE_TIMEOUT"] = "DATEV_ONLINE_TIMEOUT";
    OperationTypeEnum["DATEV_ONLINE_EXPORT_ERROR_ACCOUNT_NOT_FOUND"] = "DATEV_ONLINE_EXPORT_ERROR_ACCOUNT_NOT_FOUND";
    OperationTypeEnum["DATEV_ONLINE_DAMAGED_INVOICE_FILE"] = "DATEV_ONLINE_DAMAGED_INVOICE_FILE";
    OperationTypeEnum["INVALID_DATEV_ACCESS_TOKEN"] = "INVALID_DATEV_ACCESS_TOKEN";
    OperationTypeEnum["DATEV_ONLINE_INTEGRATION_SETUP"] = "DATEV_ONLINE_INTEGRATION_SETUP";
    /** Trip Folder */
    OperationTypeEnum["SUBMIT_FOLDER"] = "SUBMIT_FOLDER";
    /** Bank Operation types */
    OperationTypeEnum["BANK_WEB_FORM_ABORTED"] = "BANK_WEB_FORM_ABORTED";
    OperationTypeEnum["BANK_WEB_FORM_NEEDED"] = "BANK_WEB_FORM_NEEDED";
    OperationTypeEnum["BANK_IMPORT_SUCCESS"] = "BANK_IMPORT_SUCCESS";
    OperationTypeEnum["BANK_IMPORT_CONFLICT"] = "BANK_IMPORT_CONFLICT";
    OperationTypeEnum["BANK_IMPORT_FAILED"] = "BANK_IMPORT_FAILED";
    OperationTypeEnum["BANK_ADD_INTERFACE_SUCCESS"] = "BANK_ADD_INTERFACE_SUCCESS";
    OperationTypeEnum["BANK_ADD_INTERFACE_FAILED"] = "BANK_ADD_INTERFACE_FAILED";
    OperationTypeEnum["BANK_PAYMENT_SUCCESS"] = "BANK_PAYMENT_SUCCESS";
    OperationTypeEnum["BANK_PAYMENT_IN_PROGRESS"] = "BANK_PAYMENT_IN_PROGRESS";
    OperationTypeEnum["BANK_PAYMENT_FAILED"] = "BANK_PAYMENT_FAILED";
    OperationTypeEnum["BANK_DOWNLOAD_SUCCESS"] = "BANK_DOWNLOAD_SUCCESS";
    OperationTypeEnum["BANK_DOWNLOAD_FAILED"] = "BANK_DOWNLOAD_FAILED";
    /** Credit card Business  */
    OperationTypeEnum["BUSINESS_KYB_ACTION_REQUIRED"] = "BUSINESS_KYB_ACTION_REQUIRED";
    OperationTypeEnum["BUSINESS_KYB_REJECTED"] = "BUSINESS_KYB_REJECTED";
    OperationTypeEnum["BUSINESS_KYB_ACTION_CLOSED"] = "BUSINESS_KYB_CLOSED";
    OperationTypeEnum["BUSINESS_KYB_ACCEPTED"] = "BUSINESS_KYB_ACCEPTED";
    OperationTypeEnum["BUSINESS_TRANSITION"] = "BUSINESS_TRANSITION";
    OperationTypeEnum["USER_TRANSITION"] = "USER_TRANSITION";
    OperationTypeEnum["CARD_TRANSITION"] = "CARD_TRANSITION";
    OperationTypeEnum["TOP_UP_CARD_FAILED"] = "TOP_UP_CARD_FAILED";
    OperationTypeEnum["CARD_UPDATE_PIN"] = "CARD_UPDATE_PIN";
    OperationTypeEnum["UPGRADE_PHYSICAL_CARD_FAILED"] = "UPGRADE_PHYSICAL_CARD_FAILED";
    OperationTypeEnum["EXPENSE_CARD_CREATION_SUCCESS"] = "EXPENSE_CARD_CREATION_SUCCESS";
    OperationTypeEnum["EXPENSE_CARD_CREATION_FAILED"] = "EXPENSE_CARD_CREATION_FAILED";
    OperationTypeEnum["EXPENSE_CARD_TRANSACTION"] = "EXPENSE_CARD_TRANSACTION";
    OperationTypeEnum["CARD_REQUEST_LIMIT_CHANGE"] = "CARD_REQUEST_LIMIT_CHANGE";
    OperationTypeEnum["FUND_WALLET"] = "FUND_WALLET";
    OperationTypeEnum["START_KYB"] = "START_KYB";
    OperationTypeEnum["ACTIVATE_CARD"] = "ACTIVATE_CARD";
    OperationTypeEnum["SUSPEND_CARD"] = "SUSPEND_CARD";
    OperationTypeEnum["TERMINATE_CARD"] = "TERMINATE_CARD";
    OperationTypeEnum["REPORT_CARD_AS_LOST"] = "REPORT_CARD_AS_LOST";
    OperationTypeEnum["REPORT_CARD_AS_STOLEN"] = "REPORT_CARD_AS_STOLEN";
    OperationTypeEnum["RESEND_VERIFICATION_EMAIL"] = "RESEND_VERIFICATION_EMAIL";
    /* Transactions */
    OperationTypeEnum["TRANSACTION_UPDATE_CATEGORY"] = "TRANSACTION_UPDATE_CATEGORY";
    /* Data import */
    OperationTypeEnum["IMPORT_DATA_VALIDATE_ONLY_SUCCESS"] = "IMPORT_DATA_VALIDATE_ONLY_SUCCESS";
    OperationTypeEnum["IMPORT_DATA_VALIDATE_ONLY_FAILURE"] = "IMPORT_DATA_VALIDATE_ONLY_FAILURE";
    OperationTypeEnum["IMPORT_DATA_VALIDATION_ERRORS"] = "IMPORT_DATA_VALIDATION_ERRORS";
    OperationTypeEnum["IMPORT_DATA_SUCCESS"] = "IMPORT_DATA_SUCCESS";
    OperationTypeEnum["IMPORT_DATA_FAILURE"] = "IMPORT_DATA_FAILURE";
    OperationTypeEnum["SEND_EXPENSE_REMINDER_NOTIFICATION"] = "SEND_EXPENSE_REMINDER_NOTIFICATION";
    /* Vendors */
    OperationTypeEnum["UPDATE_VENDOR_RULE"] = "UPDATE_VENDOR_RULE";
    OperationTypeEnum["UPDATE_VENDOR_CONTRACTS"] = "UPDATE_VENDOR_CONTRACTS";
    OperationTypeEnum["UPDATE_VENDOR_PAYMENT_DATA"] = "UPDATE_VENDOR_PAYMENT_DATA";
    OperationTypeEnum["APPROVE_VENDOR"] = "APPROVE_VENDOR";
    /* Company */
    OperationTypeEnum["UPDATE_COMPANY_FEATURE_SETTINGS"] = "UPDATE_COMPANY_FEATURE_SETTINGS";
    OperationTypeEnum["UPDATE_COMPANY_ACCOUTING_SETTINGS"] = "UPDATE_COMPANY_ACCOUTING_SETTINGS";
    OperationTypeEnum["RESET_DEMO_DATA"] = "RESET_DEMO_DATA";
    /* Others */
    OperationTypeEnum["ASYNC_EXPORT"] = "ASYNC_EXPORT";
    OperationTypeEnum["ASYNC_EXPORT_FAILED"] = "ASYNC_EXPORT_FAILED";
    /* Analytics */
    OperationTypeEnum["FETCH_CARDS"] = "FETCH_CARDS";
    /* History of all changes */
    OperationTypeEnum["EXPORT_CHANGE_HISTORY"] = "EXPORT_CHANGE_HISTORY";
    /* Purchase Order */
    OperationTypeEnum["TRANSITION_PURCHASE_ORDER"] = "TRANSITION_PURCHASE_ORDER";
    OperationTypeEnum["LINK_TO_PURCHASE_ORDER"] = "LINK_TO_PURCHASE_ORDER";
})(OperationTypeEnum || (exports.OperationTypeEnum = OperationTypeEnum = {}));
